'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.writetpl.add', [])
  .controller('WriteTplAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/writeTpl/add/index.js